import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AuthTokenService } from './auth-token.service';

/**
 * Attach `Authorization: Bearer <token>` to every outbound `/api/*` call.
 *
 * Skipped when:
 *  - the request already carries an Authorization header (caller-overridden), or
 *  - there is no current token, or
 *  - the request URL does not look like an API call (e.g. static assets).
 */
@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(private tokens: AuthTokenService) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!this.shouldAttach(req)) {
      return next.handle(req);
    }
    const token = this.tokens.token;
    if (!token) {
      return next.handle(req);
    }
    const cloned = req.clone({
      setHeaders: { Authorization: `Bearer ${token}` },
    });
    return next.handle(cloned);
  }

  private shouldAttach(req: HttpRequest<unknown>): boolean {
    if (req.headers.has('Authorization')) {
      return false;
    }
    if (req.url.startsWith('/assets/')) return false;
    if (req.url.includes('/api/') || req.url.includes('/v1/')) return true;
    return !/\.(svg|png|jpg|jpeg|gif|ico|woff2?|ttf|css|js)$/i.test(req.url);
  }
}
